import React from 'react'
import './encyclopedia.scss'
const Encyclopedia = () => {
    return (
        <div className='page-wrapper encyclopedia-container'>
            <div className='title'>
                产于浙江温州的酱油
            </div>

            <p className='indent'>
                江心酱油是浙江温州市标志性特产，始于明末清初创立的广和、长春两大酱园。其以优质黄豆、小麦、松茸等为原料，经浸泡、蒸煮、制曲等多道工序，遵循360天日晒夜露双重自然发酵工艺酿制而成，成就了汁稠色艳、豉香浓郁、咸甜适度、自然鲜香且营养丰富的独特风味。据传在清朝道光二十六年（1846年），江心酱油与江心红曲花雕黄酒一同被列为贡品，距今已有170余年历史。因独创“2次入缸、2次发酵”的独特工艺，得名"双缸酱油"
            </p>

            <p className='indent'>
                核心工艺源自百年酱园的传承技艺，融合非物质文化遗产乌衣红曲制作工艺，兼具历史沉淀与技术创新。传承“夏伏晒、冬捞冰”的传统陈酿古法，融合现代化生产技术，实现了传统与现代的精妙融合。
            </p>


            <div className='li'>
                <div className='serialNumber'>1</div>
                名字的由来
            </div>

            <p className='indent'>
                江心之名，藏着温州瓯江的水土与匠心记忆。清道光年间，广和、长春酱园在瓯江江畔立坊酿酱，老匠人独取瓯江江心屿的清冽水源，糅合江南饱满豆麦，酿出一缸缸鲜醇的酱油。开缸时那股酱香顺着瓯江水声，飘满了温州的街巷。百年光阴流转，技艺代代传承，因位于瓯江江畔，又取江心屿之水，被温州老百姓冠名“江心”：既铭刻瓯江江心的水土根源，更承载着以江南调味精髓，佐味千家万户的匠心初心。
            </p>


            <div className='li'>
                <div className='serialNumber'>2</div>
                发展历程
            </div>

            <p className='indent'>
                1846年前夕，广和、长春酱园在温州瓯江江畔落成开业，取江心活水、江南豆麦为原料，沿用古法晒露发酵工艺酿造酱油，为江心调味之始。
            </p>


            <p className='indent'>
                20世纪初，依托瓯江航运优势，江心酱园的酱油远销浙南宁波、台州、杭州等地，成为浙菜烹饪的核心调味，在浙地市场打响名号。
            </p>


            <p className='indent'>
                1998年，江心味业前身正式注册成立，团队寻访瓯江老酱坊匠人，系统整理复刻“缸酿陈化、四季晒露”古法酿造技艺，确立“守味江南”的品牌核心。
            </p>

            <p className='indent'>
                2002年，正式启用“江心”商标，建成首座标准化生产车间，引入温控发酵缸与半自动灌装设备，实现古法工艺与现代生产融合，年产量突破千吨。
            </p>

            <p className='indent'>
                2008年，江心升级拓展醋、黄酒，复调等品类，研发适配杭帮菜“清淡鲜醇”特点的专用生抽、针对浙菜红烧的浓鲜老抽，成为浙江本地餐饮供应链的核心调味品牌。
            </p>


            <p className='indent'>
                2015年，推出低盐酱油系列健康产品，同步布局电商渠道，产品销售覆盖全国20余个省市，“江心调味”自此走出浙江、辐射全国市场。
            </p>

            
            <p className='indent'>
                2018年，“江心古法老酒汗酿造技艺”被列入温州市非物质文化遗产代表性项目名录，品牌设立非遗技艺传习所，以专业阵地守护古法酿造技艺的传承。
            </p>

           
            <p className='indent'>
                2021年，建成智能化生产基地，引入全自动无菌灌装线与数字化发酵监控系统，保留核心古法工序的同时，生产效率提升30%；复合酱料产品线同步上线，覆盖十余款浙式风味产品。
            </p>


            <p className='indent'>
                2024年，与浙菜餐饮连锁品牌达成深度战略合作，产品随浙菜出海进入东南亚市场；同年获评“温州老字号”“浙江名牌产品”，成为江南风味调味品的代表性品牌。
            </p>

            <p className='indent'>
                2024年，与浙菜餐饮连锁品牌达成深度战略合作，产品随浙菜出海进入东南亚市场；同年获评“温州老字号”“浙江名牌产品”，成为江南风味调味品的代表性品牌。
            </p>
            <p className='indent'>
                历经近两个世纪的迭代，“江心调味”从瓯江江畔的老酱园，蜕变为享誉全国的江南调味代表品牌，将地道浙味带向全国、推向海外。
            </p>
            



            <div className='li'>
                <div className='serialNumber'>3</div>
                企业现状
            </div>
            
            <p className='indent'>
                在数代匠人的传承与创新中，江心味业历经手工作坊、品牌化运营、现代化生产的变革发展，现已成为浙江省内颇具规模的江南风味调味品生产企业，产销量与品牌影响力稳居浙地调味品行业前列，是浙菜、杭帮菜调味领域的核心供应商。
            </p>

            <p className='indent'>
                旗下“江心”品牌满誉江南，先后斩获“温州老字号”“浙江名牌产品”等称号，“江心老酒汗酿造技艺”入选温州市非物质文化遗产代表性项目名录；凭借地道的江南风味，江心产品成为浙菜餐饮连锁与家庭消费的优选调味。公司严格通过ISO9001质量管理体系、HACCP食品安全管理体系等多项认证，从原料甄选到成品出厂，构建起全流程品控标准。
            </p>

            <p className='indent'>
                企业秉持“守味江南，匠心制调”的产品理念，恪守“食材本味为核心、古法工艺为根基、现代科技为助力”的酿造准则，产品矩阵覆盖酱油、食醋、黄酒、复合酱料等多品类，包含浙式生抽、杭帮菜专用调味汁、低盐健康酱油、江南风味复合酱等数十款产品，全方位满足餐饮渠道与家庭消费的多元需求。
            </p>
            
            
            <div className='li'>
                <div className='serialNumber'>4</div>
                中国浙菜十佳调味品
            </div>
            
            <div className='indent'>
                浙江江心味业有限公司生产的“江心”系列调味品，被评为“中国浙菜十佳调味品”之酱油品类。品牌负责人曾言：“守住江南的味，就是守住生活的本，这份鲜醇值得走向更广阔的餐桌。”
            </div>
            


            <div className='li'>
                <div className='serialNumber'>5</div>
                瓯菜调味四珍
            </div>
            
            <div className='indent'>
                鲜汁（江心生抽）、酱露（江心老抽）、浙醋（江心糯米醋）、酒酿（江心黄酒），位列瓯菜调味四珍
            </div>


            <div className='li'>
                <div className='serialNumber'>6</div>
                浙江辅料八珍
            </div>
            
            <div className='indent'>
                绍兴梅干菜、宁波笋干、杭州莼菜、温州鱼露、金华火腿碎、嘉兴糯米、湖州菱粉、台州虾皮。
            </div>


            <div className='li'>
                <div className='serialNumber'>7</div>
                浙江调料八珍
            </div>
            
            <div className='indent'>
                江心酱油、湖州米醋、绍兴黄酒、萧山萝卜干、温州味精、金华豆豉、杭州桂花糖、宁波虾油露，共同入选浙江调料八珍。
            </div>


            <div className='li'>
                <div className='serialNumber'>8</div>
                浙江省质量信用AAA级企业
            </div>
            
            <div className='indent'>
                江心味业一贯重视产品质量管理，恪守“匠心制调、品质为本”的经营理念，注重企业质量诚信与承诺，获得相关部门充分肯定。根据浙江省质量技术监督局相关文件认定，江心味业连续多年被评为“浙江省质量管理先进企业”及“浙江省质量信用AAA级企业”。作为传承近两百年的调味品企业，江心味业得以长期稳健发展，源于企业上下坚守古法酿造的匠心，对产品品质精益求精，严守食品安全底线，以高品质调味佳品奉献于社会，获得广大消费者的认可。
            </div>
        </div>
    )
}

export default Encyclopedia